module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Bullet_Hole-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole3#toc_marker-4"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole4#toc_marker-5"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole5#toc_marker-6"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole6#toc_marker-7"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole7#toc_marker-8"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole8#toc_marker-9"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole9#toc_marker-10"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole10#toc_marker-11"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole11#toc_marker-12"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole12#toc_marker-13"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole13#toc_marker-14"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole14#toc_marker-15"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-entry"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/Bullet_Hole15#toc_marker-16"
    }
  }, [_vm._v("Contact Us")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1abbdd40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Bullet_Hole-2.vue
// module id = 66
// module chunks = 0